import cn from 'classnames'
import { Theme } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    background: theme.palette?.pageBackground?.main,
    width: '100%',
    overflow: 'hidden',
  },
  withHeight: {
    minHeight: 'calc(100vh - 70px)',
  },
}))

export interface PageBackgroundProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  withoutHeight?: boolean
}

const PageBackground = ({ withoutHeight, className, ...rest }: PageBackgroundProps) => {
  const classes = useStyles()
  return (
    <div
      className={cn(className, classes.root, {
        [classes.withHeight]: !withoutHeight,
      })}
      {...rest}
    />
  )
}

export default PageBackground
